import { createStyleSheet } from 'Components/foundation/stylesheets';

export const stylesheet = createStyleSheet({
  chipsContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 6px',
    borderRadius: '8px',
    backgroundColor: '#F9F9F9',
  },
  chips: {
    backgroundColor: 'red',
  },
});

export default stylesheet;
